module.exports = __webpack_public_path__ + "img/zh_CN-box4-text-dark.095ce3f8.png";